import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';
import { useSiteImage } from '@/hooks/useSiteImage';

export default function StepTreatSection() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';
  const imageUrl = useSiteImage('threeStep.step02.image', 'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/3ae524b2-2a5f-4ebc-a9d6-d945ef3fc7a0_Sample_Real_Serum_Containerbox.png');

  return (
    <section className="w-full bg-[#2A2A2A] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="flex flex-col gap-6 order-2 lg:order-1">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#D4A017] text-white text-sm font-bold flex items-center justify-center">02</span>
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#D4A017] font-medium">{t('threeStep.step02.badge')}</span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl font-bold text-white leading-[1.15]">{t('threeStep.step02.name')}</h2>

            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-white/80">{t('threeStep.step02.price')}</span>
              <span className="text-xs text-white/40 font-light">{t('threeStep.step02.volume')}</span>
            </div>

            <p className="text-sm text-white/50 font-light leading-[1.9]">
              {t('threeStep.step02.desc')}
            </p>

            <div className="flex flex-col gap-3">
              <span className="text-[11px] tracking-[0.15em] uppercase text-white/60 font-medium">{t('threeStep.step02.ingredientsLabel')}</span>
              <div className="flex flex-wrap gap-2">
                {['Niacinamide 5%', 'Tranexamic Acid 1-2%', 'Peptide', 'Ceramide'].map((ing) => (
                  <span key={ing} className="text-[10px] tracking-[0.08em] uppercase px-3 py-1.5 rounded-full bg-white/10 text-[#D4A017] font-medium">{ing}</span>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <span className="text-[11px] tracking-[0.15em] uppercase text-white/60 font-medium">{t('threeStep.step02.howToUse')}</span>
              <ol className="flex flex-col gap-2 list-decimal list-inside">
                <li className="text-xs text-white/40 font-light">{t('threeStep.step02.use1')}</li>
                <li className="text-xs text-white/40 font-light">{t('threeStep.step02.use2')}</li>
                <li className="text-xs text-white/40 font-light">{t('threeStep.step02.use3')}</li>
                <li className="text-xs text-white/40 font-light">{t('threeStep.step02.use4')}</li>
                <li className="text-xs text-white/40 font-light">{t('threeStep.step02.use5')}</li>
              </ol>
            </div>

            <Link
              to={prefix + '/products/daily-rescue-serum'}
              className="mt-2 px-7 py-3 bg-[#D4A017] text-[#2A2A2A] text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#B8860B] transition-colors cursor-pointer w-fit text-center font-medium"
            >
              {t('threeStep.step02.cta')}
            </Link>
          </div>

          <div className="relative rounded-2xl overflow-hidden h-80 md:h-[480px] bg-[#1A1A1A] order-1 lg:order-2">
            <img
              src={imageUrl}
              alt="Daily Rescue Serum — Step 02 TREAT"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}